import { IPlatformOrganizationType } from '../entities/IPlatformConfiguration';
import { ETypeOfOrganization, IOrganizationType } from '../entities/IOrganization';

const VALID_ORGANIZATION_TYPES = new Set<string>(Object.values(ETypeOfOrganization));

export const getOrganizationTypeLabel = (type: IPlatformOrganizationType, lcid?: number): string => {
    const names = type.name ?? [];
    const matched = lcid != null
        ? names.find(name => name.lcid === lcid)?.label
        : undefined;
    const fallback = names.find(name => name.label)?.label;

    return matched || fallback || (type.key != null ? String(type.key) : '');
};

export const mapPlatformOrganizationTypeToOrganizationType = (
    type: IPlatformOrganizationType,
    lcid?: number
): IOrganizationType | undefined => {
    const rawKey = type.key;
    if (rawKey == null) {
        return undefined;
    }

    const stringKey = String(rawKey);
    if (!VALID_ORGANIZATION_TYPES.has(stringKey)) {
        return undefined;
    }

    return {
        id: stringKey,
        name: getOrganizationTypeLabel(type, lcid),
        key: stringKey as ETypeOfOrganization
    };
};

export const mapPlatformOrganizationTypesToOrganizationTypes = (
    types: IPlatformOrganizationType[] | undefined,
    lcid?: number
): IOrganizationType[] =>
    (types ?? [])
        .filter(type => type.isActive !== false)
        .map(type => mapPlatformOrganizationTypeToOrganizationType(type, lcid))
        .filter((type): type is IOrganizationType => type != null);
